import {Injectable} from '@angular/core';
import {environment} from "../../../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {RepoEntry} from "../../../model/v3/documents";

@Injectable({
  providedIn: 'root'
})
export class DocumentRestV3Service {

  constructor(private http: HttpClient) {
  }

  private url(method: string) {
    return `${environment.eventsApiBase}/v1${method}`;
  }

  public listDocuments(schoolId: number): Observable<RepoEntry> {
    return this.http.get<RepoEntry>(this.url(`/schools/${schoolId}/documents`));
  }

  public getDocumentLink(schoolId: number, path: string): Observable<string> {
    return this.http.get(this.url(`/schools/${schoolId}/documents/${path}`), {responseType: "text"});
  }

  public refreshDocumentsRepository(schoolId: number): Observable<any> {
    const params = new HttpParams().append("action", "refresh");
    return this.http.post(this.url(`/schools/${schoolId}/documents`), null, {params});
  }
}
